var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-template',{attrs:{"loading":_vm.loading,"total":_vm.total,"table-data":_vm.tableData,"current-page":_vm.page,"table-config":_vm.tableConfig,"search-config":_vm.searchConfig},on:{"onAdd":function($event){return _vm.$router.push('./add')},"onSearch":_vm.onSearch,"onChangePage":_vm.onPageChange,"onHandle":_vm.onHandle}})
}
var staticRenderFns = []

export { render, staticRenderFns }